import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Haalt de woonplaats uit een adreslabel.
 * "Dorpsstraat 1, 1234 AB Rotterdam" → "Rotterdam"
 * "Schiphol" → "Schiphol"
 */
export function cityFromLabel(label: string | null | undefined): string {
  if (!label) return "";
  const parts = label.split(",");
  const lastPart = parts.at(-1) ?? label;
  // Verwijder postcode (1234 AB) indien aanwezig.
  const city = lastPart.replace(/^\d{4}\s?[A-Z]{2}\s*/i, "").trim();
  return city || lastPart;
}
